/* Phone bottom navigation — a Liquid Glass capsule.

   The selection pill: sized to one item and moved with translateX on a
   critically damped spring, stretching with its speed like a drop of liquid
   (Web Animations, transform only). A new tap mid-flight starts from where
   the pill is and how fast it is moving at that instant, so it bends toward
   the new item instead of jumping.

   Which item is lit:
   - the page's own item (data-active, set by Liquid from the template);
   - Shop while the phone menu is open, Wishlist while its panel is open.
     Both are read off aria-expanded, so closing them any other way (Escape,
     the header X, a tap outside) sends the pill back.

   Going to another page: the pill moves to the choice at once (no journey
   across the other items) and the next page settles it in with a soft
   swell. Tapping the current page's item never reloads it.

   Minimising: scrolling down past the first screen tucks the capsule in
   (.is-min); any scroll up, or reaching the end of the page, brings it back. */
(function () {
  if (window.__mBnav) return;
  window.__mBnav = true;

  var KEY = 'm-bnav-from';

  function store(key, value) {
    try {
      if (value) sessionStorage.setItem(key, value);
      else sessionStorage.removeItem(key);
    } catch (e) {}
  }

  function read(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }

  function init() {
    var nav = document.querySelector('[data-m-bnav]');
    if (!nav) return;

    var pill = nav.querySelector('.m-bnav__pill');
    // A page cached from before the pill existed: leave the plain bar alone.
    if (!pill) return;
    var items = Array.prototype.slice.call(nav.querySelectorAll('[data-m-bnav-item]'));
    var burger = document.querySelector('[data-m-burger]');
    var shopBtn = nav.querySelector('[data-m-bnav-item="shop"]');
    var wishBtn = nav.querySelector('[data-m-bnav-item="wishlist"]');
    var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');
    var current = null;
    var anim = null;

    function find(key) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].getAttribute('data-m-bnav-item') === key) return items[i];
      }
      return null;
    }

    // The pill is 6px narrower than an item, centred on it.
    function targetX(el) {
      return el.offsetLeft + 3;
    }

    function size() {
      if (items[0]) pill.style.width = items[0].offsetWidth - 6 + 'px';
    }

    /* The pill moves on a critically damped spring (Apple's default: damping
       1.0, no overshoot) rather than a fixed-duration curve, so it eases out
       of rest, travels, and settles softly. The spring is solved exactly:
         x(t) = T + (d0 + (v0 + w·d0)·t)·e^(−w·t),  d0 = x0 − T
         v(t) = (v0 − w·(v0 + w·d0)·t)·e^(−w·t)
       and sampled into Web Animation keyframes. The "liquid" stretch follows
       the pill's speed at each sample, so it swells mid-journey and relaxes
       as it slows — nothing snaps. */
    var RESPONSE = 0.55;               // seconds; Apple's "response"
    var W = (2 * Math.PI) / RESPONSE;  // natural frequency
    var SETTLE = 9.2 / W;              // (1 + w·t)·e^(−w·t) < 0.1%
    var spring = null;                 // { T, d0, v0 } of the running spring

    function springAt(sp, t) {
      var B = sp.v0 + W * sp.d0;
      var e = Math.exp(-W * t);
      return { x: sp.T + (sp.d0 + B * t) * e, v: (sp.v0 - W * B * t) * e };
    }

    // Where the pill is right now and how fast it is going — mid-flight
    // included — so a new tap carries the motion on instead of restarting it.
    function live() {
      if (anim && spring && anim.currentTime != null) {
        return springAt(spring, anim.currentTime / 1000);
      }
      var t = getComputedStyle(pill).transform;
      if (!t || t === 'none') return null;
      // transform-origin is applied outside the matrix, so m41 is exactly the
      // translateX in play.
      return { x: new DOMMatrixReadOnly(t).m41, v: 0 };
    }

    function stretchFor(v) {
      var sx = 1 + Math.min(0.2, Math.abs(v) / 4000);
      return { sx: sx, sy: 1 - (sx - 1) * 0.4 };
    }

    function place(key, animate) {
      var el = find(key);
      items.forEach(function (i) { i.classList.toggle('is-active', i === el); });
      current = key;
      if (!el) {
        pill.style.opacity = '0';
        return;
      }

      var to = targetX(el);
      var now = live();
      if (anim) { anim.cancel(); anim = null; }
      spring = null;
      pill.style.transform = 'translateX(' + to + 'px)';
      pill.style.opacity = '1';

      if (!animate || !now || Math.abs(to - now.x) < 1 || reduceMq.matches || !pill.animate) return;

      var sp = { T: to, d0: now.x - to, v0: now.v };
      var steps = Math.ceil(SETTLE * 60);
      var frames = [];
      for (var i = 0; i <= steps; i++) {
        var st = springAt(sp, (i / steps) * SETTLE);
        var sc = i === steps ? { sx: 1, sy: 1 } : stretchFor(st.v);
        var x = i === steps ? to : st.x;
        frames.push({ transform: 'translateX(' + x.toFixed(2) + 'px) scale(' + sc.sx.toFixed(4) + ',' + sc.sy.toFixed(4) + ')' });
      }
      spring = sp;
      anim = pill.animate(frames, { duration: SETTLE * 1000, easing: 'linear' });
      anim.onfinish = function () { anim = null; spring = null; };
    }

    function wanted() {
      if (burger && burger.getAttribute('aria-expanded') === 'true') return 'shop';
      if (wishBtn && wishBtn.getAttribute('aria-expanded') === 'true') return 'wishlist';
      return nav.getAttribute('data-active') || null;
    }

    function sync() {
      var k = wanted();
      if (shopBtn) shopBtn.setAttribute('aria-expanded', k === 'shop' ? 'true' : 'false');
      if (k === 'shop' || k === 'wishlist') expand();
      if (k !== current) place(k, true);
    }

    if (window.MutationObserver) {
      var mo = new MutationObserver(sync);
      [burger, wishBtn].forEach(function (el) {
        if (el) mo.observe(el, { attributes: true, attributeFilter: ['aria-expanded'] });
      });
    }

    nav.addEventListener('click', function (e) {
      var it = e.target.closest('[data-m-bnav-item]');
      if (!it) return;
      var key = it.getAttribute('data-m-bnav-item');
      var menuOpen = burger && burger.getAttribute('aria-expanded') === 'true';

      if (key === 'shop') {
        e.preventDefault();
        if (burger) burger.click();
        return;
      }

      // minery-wishlist.js owns the panel; sync() follows its aria-expanded.
      if (key === 'wishlist') {
        if (menuOpen) burger.click();
        return;
      }

      // The page you are already on: no reload (that was a white flash).
      // Close whatever is open over it, or else scroll back to the top, as
      // tapping the current tab does on iOS.
      if (key === nav.getAttribute('data-active')) {
        e.preventDefault();
        if (menuOpen) burger.click();
        else if (!(wishBtn && wishBtn.getAttribute('aria-expanded') === 'true')) {
          window.scrollTo({ top: 0, behavior: reduceMq.matches ? 'auto' : 'smooth' });
        }
        return;
      }

      // Another page. The pill goes straight to the choice — no journey
      // across the other items, which read as briefly selecting them while
      // the next page loaded — and the menu is left as it is rather than
      // folded on the way out. The next page settles the pill in place.
      store(KEY, '1');
      place(key, false);
    });

    /* --- Minimise on scroll ------------------------------------------- */

    var lastY = window.scrollY;
    var scrollRaf = 0;

    function expand() { nav.classList.remove('is-min'); }

    function onScroll() {
      scrollRaf = 0;
      var y = window.scrollY;
      var dy = y - lastY;
      var atEnd = window.innerHeight + y >= document.documentElement.scrollHeight - 2;
      var busy = wanted() === 'shop' || wanted() === 'wishlist';

      if (reduceMq.matches || busy || atEnd || y < 120) {
        expand();
        lastY = y;
        return;
      }
      // A little hysteresis so a jittery thumb doesn't flicker it.
      if (dy > 8) { nav.classList.add('is-min'); lastY = y; }
      else if (dy < -8) { expand(); lastY = y; }
    }

    window.addEventListener('scroll', function () {
      if (!scrollRaf) scrollRaf = requestAnimationFrame(onScroll);
    }, { passive: true });

    // Touching a minimised bar brings it back at once.
    nav.addEventListener('pointerdown', expand);

    /* --- First paint --------------------------------------------------- */

    size();
    var arrived = read(KEY);
    store(KEY, null);
    place(wanted(), false);

    // Arrived by tapping the bar: the pill settles into its item — a soft
    // swell from slightly small, on the spring's own curve — rather than
    // travelling in from the old page's item.
    if (arrived && current && !reduceMq.matches && pill.animate) {
      pill.animate([
        { transform: pill.style.transform + ' scale(0.9)', opacity: 0 },
        { transform: pill.style.transform + ' scale(1)', opacity: 1 }
      ], { duration: 420, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
    }

    // offsetLeft/offsetWidth are 0 while the bar is hidden above 900px, so
    // re-measure whenever the width changes (rotation, desktop → phone).
    var raf = 0;
    window.addEventListener('resize', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        size();
        place(current, false);
      });
    });

    // Back/forward cache restores the page as it was left; re-sync it.
    // The menu is deliberately left open when a bar link leaves the page, so
    // coming back to that page from the cache closes it here.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        if (burger && burger.getAttribute('aria-expanded') === 'true') burger.click();
        expand();
        size();
        place(wanted(), false);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
